import { Component, Input, HostBinding } from '@angular/core';

export class ChBadgeComponent {
  css = ' badge badgePosition';
  num: number;

   max = 99;
    set cssClass(css) {
    this.css = css + this.css;
  }
  get cssClass() {
    return this.css;
  }

    set text(num) {
    this.num = isNaN(num) ? num : Number(num);
    const surplusText = this.max + '+';
    let number;
    this.num > this.max ? number = surplusText : number = this.num;
    this.num = number;
  }

  get text() {
    return this.num;
  }
  /**
   * 
   */
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ch-badge',
  template: '',
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'max': [{ type: Input },],
'cssClass': [{ type: HostBinding, args: ['class', ] },{ type: Input },],
'text': [{ type: HostBinding, args: ['innerText', ] },{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
